exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".float {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: row;\r\n      flex-direction: row;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n}\r\n.float .radio {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  margin-left: 5px;\r\n}\r\n.float label {\r\n  margin: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/message/informMessageEdit.component.css
// module id = ../../../../../src/app/message/informMessageEdit.component.css
// module chunks = main